import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import {Typography, Grid2, Box, AppBar, Tab, Tabs, Button, Grid, TableBody, TableCell, TableContainer, Table, TableHead, TableRow, TableSortLabel, Avatar} from '@mui/material';
import newUser from '../../assets/icons/newUserIcon.svg';
import totalRideIcon from '../../assets/icons/vehicle.svg';
import increment from '../../assets/icons/increment.svg';
import decrement from '../../assets/icons/decrement.svg';
import CancelledRideIcon from '../../assets/icons/cancelledRide.svg';
import activeRidesIcon from '../../assets/icons/activeRides.svg';
import earningsIcon from '../../assets/icons/earningsIcon.svg';
import cancelledShipment from '../../assets/images/CancelledCard.svg';
import { useState } from "react";
import greenTick from '../../assets/images/greenTickSquare.svg';
import PropTypes from 'prop-types';
import assignedShipment from '../../assets/images/Asssigned.svg';
import unassignedShipment from '../../assets/images/UnassignedCard.svg';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LineChart } from '@mui/x-charts/LineChart';
import config from '../../config/config.js';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import latLngMarker from '../../assets/icons/latLngMark.svg';
import constants from '../../constant.js';
import { useNavigate } from 'react-router-dom';
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other} >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yPropsBooking(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const ShuttleDashboard = ({cityFilter}) => {
    const theme = useTheme();
    const serverUrl = config.serverUrl;
    const currentDate = dayjs(); // Get the current date
    const sevenDayBefore = currentDate.subtract(7, 'day');
    const [driverStatsVal, setDriverStatsVal] = useState("1");
    const [downloadStatsVal, setDownloadStatsVal] = useState("1");
    const [bookingTab, setBookingTab] = useState(0);
    const [bookingStartDate, setBookingStartDate] = React.useState(sevenDayBefore); // Default start date
    const [bookingEndDate, setBookingEndDate] = React.useState(currentDate);
    const [headerPeriod, setHeaderPeriod] = useState(1);      //card Details Period
    const [headerData, setHeaderData] = useState([]);      //card Details Data
    const [chartData, setChartData] = useState(null);
    const [downloadChartData, setDownloadChartData] = useState(null);
    const [bookingChartData, setBookingChartData] = useState(null);

    const [latLngData, setLatLngData] = useState([]);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [bound, setBound] = useState(false);
    const [mapInstance, setMapInstance] = useState(null);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (mapInstance && latLngData && latLngData.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            latLngData.forEach((point) =>
                bounds.extend({ lat: point.lat, lng: point.lng })
            );
            mapInstance.fitBounds(bounds);
        }
    }, [latLngData, bound]);

    const handleBookingStaticsChange = (event, newValue) => {
        setBookingTab(newValue);
    };

    const driverStaticsValue = (text) => {
        setDriverStatsVal(text);
    }

    const downloadStaticsValue = (text) => {
        setDownloadStatsVal(text);
    }

    const handleInputChange = (e) => {
        setHeaderPeriod(e.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    //fetching header card details
    React.useEffect(() => {
        const fetchCarDetailsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/shuttle/dashboard/card_details`;
                const obj={
                    token: token, timestamp: timestamp, period: headerPeriod, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    setHeaderData(response.data);
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchCarDetailsData();
    }, [headerPeriod, cityFilter]);

    //fetching revenue
    React.useEffect(() => {
        const fetchRevenue = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/shuttle/dashboard/fetch_revenue`;
                const obj={
                    token: token, timestamp: timestamp, period: driverStatsVal, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const driverEarningStatics = response.data;

                    const xAxisData = Object.keys(driverEarningStatics);
                    const seriesData = xAxisData.map(day => driverEarningStatics[day].earnings);

                    setChartData({
                        labels: xAxisData,
                        seriesData: seriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchRevenue();
    }, [driverStatsVal, cityFilter]);


    //fetching users
    React.useEffect(() => {
        const fetchDownloadStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/shuttle/dashboard/fetch_users`;
                const obj={
                    token: token, timestamp: timestamp, period: downloadStatsVal, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const downloadStatisticsData = response.data;

                    const labels = Object.keys(downloadStatisticsData); 
                    const labelsData = Object.values(downloadStatisticsData); 
                    const metricKeys = Object.keys(labelsData[0]); 

                    const formattedSeriesData = metricKeys.map(metric => ({
                        name: metric,
                        data: labels.map(day => downloadStatisticsData[day][metric])
                    }));

                    // Set chart data
                    setDownloadChartData({
                        labels: labels,
                        seriesData: formattedSeriesData
                    });

                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDownloadStatisticsData();
    }, [downloadStatsVal, cityFilter]);

    //fetching booking statics for different types of rides
    React.useEffect(() => {
        const fetchBookingStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const stDate = formatDate(bookingStartDate);
                const endDate = formatDate(bookingEndDate);
                const timestamp = new Date().getTime();
            
                const url = `${serverUrl}/shuttle/dashboard/booking_statistics`;
                const obj={
                    token: token, timestamp: timestamp, 
                    status: bookingTab==0 ? constants.shuttleBookingStatus.ENDED : bookingTab==1 ? constants.shuttleBookingStatus.PICKED_UP : bookingTab==2 ? constants.shuttleBookingStatus.CANCELLED : 1,
                    start_date: stDate,
                    end_date: endDate,
                    city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const bookingStatisticsData = response.data;

                    const xAxisData = bookingStatisticsData.map(item => new Date(item.date).toLocaleDateString('en-CA'));
                    const seriesData = bookingStatisticsData.map(item => item.total_count);

                    setBookingChartData({
                        labels: xAxisData,
                        seriesData: seriesData
                    });

                    const latLngArray = [];
                    bookingStatisticsData.forEach((day) => {
                        day.requests.forEach((request) => {
                            latLngArray.push({
                                id: request.request_id,
                                lat: parseFloat(request.pickup_latitude), // Convert latitude to number
                                lng: parseFloat(request.pickup_longitude), // Convert longitude to number
                            });
                        });
                    });

                    setLatLngData(latLngArray);
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchBookingStatisticsData();
    }, [bookingTab, bookingStartDate, bookingEndDate, cityFilter]);

    const { isLoaded, loadError } = useGoogleMapsLoader();

    const containerStyle = {
        width: '98%',
        height: '500px',
      };
    const center = {
        lat: latLngData ? latLngData.reduce((sum, point) => sum + point.lat, 0) / latLngData.length : 0,
        lng: latLngData ? latLngData.reduce((sum, point) => sum + point.lng, 0) / latLngData.length : 0,
    };

    const onLoad = React.useCallback(function callback(map) {
        setMapInstance(map);
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMapInstance(null);
    }, []);

    return(
        <div>
           
            {/* <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Dashboard</Typography> */}

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <select style={{minWidth:'180px', padding:'1%', borderRadius:'10px'}} value={headerPeriod} onChange={handleInputChange}>
                        <option value="1">Today</option>
                        <option value="2">Last 7 Days</option>
                        <option value="3">Last 30 Days</option>
                    </select>
                </Grid2>

                <Grid2 container
                    sx={{
                        marginTop: '1%',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)', // 4 cards per row
                        gap: '20px', // Space between cards
                    }}
                >
                    {/* Card 1: Total Rides */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#F3F8FF',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={totalRideIcon} alt="totalRideIcon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Bookings</Typography>
                        {headerData?.totalBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.totalBookings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.totalBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.totalBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.totalBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.totalBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 2: Booked Bookings */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#E0FAFFB2',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={assignedShipment} alt="totalRideIcon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Booked Bookings</Typography>
                        {headerData?.bookedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.bookedBookings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.bookedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.bookedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.bookedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.bookedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Missed Rides */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#EEEEEEB2',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={unassignedShipment} alt="cancelledRideIcon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Missed Bookings</Typography>
                        {headerData?.missedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.missedBookings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.missedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.missedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.missedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.missedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Active Rides Card */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#FFFBF0',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={activeRidesIcon} alt="Active Rides Icon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Active Bookings</Typography>
                        {headerData?.ongoingBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.ongoingBookings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.ongoingBookings?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.ongoingBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.ongoingBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.ongoingBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Completed Bookings Card */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#DFFFE2B2',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={greenTick} alt="Earning" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Completed Bookings</Typography>
                        {headerData?.completedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.completedBookings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.completedBookings?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.completedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.completedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.completedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Cancelled Rides */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#FFDDDDB2',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={cancelledShipment} alt="cancelledRideIcon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Cancelled Bookings</Typography>
                        {headerData?.cancelledBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.cancelledBookings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.cancelledBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.cancelledBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.cancelledBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.cancelledBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Total Earnings Card */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#EFFBF7',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={earningsIcon} alt="Earning" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Earning</Typography>
                        {headerData?.totalEarnings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData?.totalEarnings.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.totalEarnings?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.totalEarnings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.totalEarnings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.totalEarnings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* New User */}
                    <Grid2
                        item
                        sx={{
                            backgroundColor: '#F3F8FF',
                            padding: '4%',
                            borderRadius: '12px',
                            minHeight: '150px',
                        }}
                    >
                        <img src={newUser} alt="New Drivers Icon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>New Users</Typography>
                        {headerData?.newUsers && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.newUsers.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.newUsers?.change >= 0 ? (
                                <img src={increment} alt="Increment Icon" />
                            ) : (
                                <img src={decrement} alt="Decrement Icon" />
                            )}
                            {headerData?.newUsers && (
                                <Typography
                                    sx={{
                                        color: headerData.newUsers.change >= 0 ? '#0DBA78' : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.newUsers.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                </Grid2>
            </Grid2>

            <Grid2 container size={12} spacing={2}>
                <Grid2 item size={6} className="mainBox" sx={{marginTop:'1%'}}>
                    <Grid2 item container size={12}>
                        <Grid2 item size={6}>
                            <Typography sx={{fontSize:'20px', color:'#93A3AB', paddingTop:'1%', display:'flex', alignItems:'center'}}>Revenue <KeyboardArrowDownIcon sx={{color:'#93A3AB'}} /></Typography>
                            {/* <Typography sx={{fontSize:'24px', color:'#1A1E25' }}>$11.643</Typography>
                            <Typography sx={{fontSize:'12px', color:'#93A3AB', fontWeight:500}}><span style={{color:'#65C565'}}>+3.4%</span> from last period</Typography> */}
                        </Grid2>
                        <Grid2 item size={6}>
                            <Grid2 container>
                                <Grid2 item sx={{marginLeft:'auto'}}>
                                    <Button className = {`daysWeeklyMonthly ${driverStatsVal === '1' ? 'active' : ''}`}
                                    onClick={()=>driverStaticsValue('1')}>Days</Button>

                                    <Button className={`daysWeeklyMonthly ${driverStatsVal === '2' ? 'active' : ''}`} 
                                    onClick={()=>driverStaticsValue('2')}>Weekly</Button>

                                    <Button className={`daysWeeklyMonthly ${driverStatsVal === '3' ? 'active' : ''}`}
                                    onClick={()=>driverStaticsValue('3')}>Monthly</Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2>
                        <Grid2 item>
                            <LineChart
                                xAxis={[{ scaleType: 'point', data: chartData?.labels || [] }]}
                                series={[
                                    {
                                    data: chartData?.seriesData || [],
                                    label:'Revenue'
                                    },
                                ]} width={500} height={600}
                            />
                        </Grid2>
                    </Grid2>
                </Grid2>

                <Grid2 item size={6} className="mainBox" sx={{marginTop:'1%'}}>
                    <Grid2 item container size={12}>
                        <Grid2 item size={6}>
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>New User Visits</Typography>
                        </Grid2>
                        <Grid2 item size={6}>
                            <Grid2 container>
                                <Grid2 item sx={{marginLeft:'auto'}}>
                                    <Button className = {`daysWeeklyMonthly ${downloadStatsVal === '1' ? 'active' : ''}`}
                                    onClick={()=>downloadStaticsValue('1')}>Days</Button>

                                    <Button className={`daysWeeklyMonthly ${downloadStatsVal === '2' ? 'active' : ''}`} 
                                    onClick={()=>downloadStaticsValue('2')}>Weekly</Button>

                                    <Button className={`daysWeeklyMonthly ${downloadStatsVal === '3' ? 'active' : ''}`}
                                    onClick={()=>downloadStaticsValue('3')}>Monthly</Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2> 

                    <Grid2 item>
                        {downloadChartData && (
                            <BarChart
                                xAxis={[{ scaleType: 'band', data: downloadChartData.labels }]}
                                series={downloadChartData.seriesData}
                                width={500}
                                height={600}
                            />
                        )}
                    </Grid2>
                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item container size={12}>
                    <Grid2 item size={5}>
                        <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Booking Statics</Typography>
                    </Grid2>
                    <Grid2 item size={7}>
                        <AppBar position="static" sx={{minHeight:"10px", maxHeight:'48px', borderRadius:'8px', backgroundColor:'#F9F9F9', padding:'4px', boxShadow:'none'}}>
                            <Tabs value={bookingTab} onChange={handleBookingStaticsChange} indicatorColor="secondary"
                            textColor="inherit" variant="fullWidth" aria-label="full width tabs example" >
                                <Tab label="Completed Trips" className={bookingTab === 0 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(0)} />
                                <Tab label="Ongoing Trips" className={bookingTab === 1 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(3)} />
                                <Tab label="Cancelled Trips" className={bookingTab === 2 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(2)} />
                            </Tabs>
                        </AppBar>
                    </Grid2>
                </Grid2>

                <Grid2 item container size={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={[
                            'DatePicker',
                            'MobileDatePicker',
                            'DesktopDatePicker',
                            'StaticDatePicker',
                            ]}
                        >
                            <Grid2 container>
                                <Grid2 item>
                                    <DemoItem label="">
                                        <DatePicker sx={{height:'40px'}} defaultValue={dayjs(bookingStartDate)} onChange={(newValue) => setBookingStartDate(newValue)} />
                                    </DemoItem>
                                </Grid2>
                                <Grid2 item>
                                    <DemoItem label="">
                                        <DatePicker sx={{height:'60px'}} defaultValue={dayjs(bookingEndDate)} onChange={(newValue) => setBookingEndDate(newValue)} />
                                    </DemoItem>
                                </Grid2>
                            </Grid2>
                            
                            
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid2>
                <hr/>

                <Grid2 item container size={12} spacing={2}>
                    <Grid2 item size={6}>
                        <TabPanel value={bookingTab} index={0} dir={theme.direction}>
                            <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>Completed Trips</Typography>
                                
                                <LineChart
                                    xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                    series={[
                                        {
                                        data: bookingChartData?.seriesData || [],
                                        label:'Ride Count'
                                        },
                                    ]} width={500} height={460}
                                />
                            </Grid2>
                        </TabPanel>
                        <TabPanel value={bookingTab} index={1} dir={theme.direction}>
                            <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>Ongoing Trips</Typography>
                                
                                <LineChart
                                    xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                    series={[
                                        {
                                        data: bookingChartData?.seriesData || [],
                                        label:'Ride Count'
                                        },
                                    ]} width={500} height={460}
                                />
                            </Grid2>
                        </TabPanel>
                        <TabPanel value={bookingTab} index={2} dir={theme.direction}>
                            <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>Cancelled Trips</Typography>
                                
                                <LineChart
                                    xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                    series={[
                                        {
                                        data: bookingChartData?.seriesData || [],
                                        label:'Ride Count'
                                        },
                                    ]} width={500} height={460}
                                />
                            </Grid2>
                        </TabPanel>
                    </Grid2>

                    <Grid2 item size={6}>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={20} onLoad={onLoad} onIdle={()=> { setBound(true)}} onUnmount={onUnmount}>
                                {latLngData.length > 0 && latLngData.map((marker) => {
                                    return(
                                        <Marker
                                            key={marker.id}
                                            position={{ lat: marker.lat, lng: marker.lng }}
                                            title={marker.request_id} 
                                            icon={{
                                                url: latLngMarker,
                                                scaledSize: new window.google.maps.Size(20, 20) 
                                            }}
                                        />
                                    )
                                } )}
                            </GoogleMap>
                        ): (<>Loading</>)}
                    </Grid2>
                </Grid2>
            </Grid2>

        </div>
    )
}

export default ShuttleDashboard;